import PropTypes from 'prop-types';
import React from 'react';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick-theme.scss';
import 'slick-carousel/slick/slick.scss';

/**
 * Wrapper for Slickslider to add the CSS as part of the components
 */
export default class Slider extends React.Component {
    static propTypes = {
        settings: PropTypes.object,
    };

    static defaultProps = {
        settings: {},
        className: '',
    };

    render() {
        return (
            <div
                className={`components-JobComponents-Slider-Slider ${this.props.className}`}
            >
                <SlickSlider ref={this.props.ref} {...this.props.settings}>
                    {this.props.children}
                </SlickSlider>
            </div>
        );
    }
}
